module.exports = __webpack_public_path__ + "img/log.a4f46ff3.svg";